export default __webpack_public_path__ + "static/media/teamwork.3512cd4b.svg";